import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  // Badge,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as clearanceAction from "../../store/Y2xlYXJhbmNl/actions"
import * as auditAction from "../../store/c2FsZXNG/actions" //for using employee options
import { toast, ToastContainer } from "react-toastify"

const ClearanceLevel2 = (props) => {
  const { dispatch, searchBarStyle } = props
  const { SearchBar } = Search
  const title = "Clearance Level 2"

  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  useEffect(() => {
    dispatch(clearanceAction.loadRecordsMetaData())
    dispatch(auditAction.loadEmployee())
    dispatch(clearanceAction.loadClearanceList())
  }, [1])
  const specificDispatch = useDispatch()

  const clearanceUpdate = useSelector((state) => state.clearanceLevel2)
  //consolelog(clearanceUpdate, "clearance Update")

  const { clearanceMetaData = {}, clearance_details = [] } = clearanceUpdate
  //Date format

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //consolelog(user, "user details from session")
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //Clearance initial state
  const [clearanceData, setClearanceData] = useState({
    fromDate: "",
    toDate: "",
    leadNo: "",
    date: "",
  })

  //handle change

  const handleChange = async (e) => {
    setClearanceData({ ...clearanceData, [e.target.name]: e.target.value })
  }
  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])

  //counter modal
  const [todayList, setTodayList] = useState(false)
  const [weeklyList, setWeeklyList] = useState(false)
  const [monthlyList, setMonthlyList] = useState(false)
  const [totalList, setTotalList] = useState(false)

  //clearance modal
  const [clearanceModal, setClearanceModal] = useState(false)
  const handleModal = () => setClearanceModal(false)
  // const handleModal = () => setClearanceModal(false)
  // const [confirmModal, setConfirmModal] = useState(false)
  // const handleConfirmModal = () => setConfirmModal(false)

  //reset filter form

  const resetForm = () => {
    setCompanies([])
    setBranches([])

    setClearanceData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    dispatch(clearanceAction.loadClearanceList())
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(clearanceMetaData) &&
    clearanceMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //apply filter submit

  const clearanceFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchFromDate =
      clearanceData && clearanceData.fromDate
        ? moment(clearanceData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      clearanceData && clearanceData.toDate
        ? moment(clearanceData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      clearanceData && clearanceData.leadNo ? clearanceData.leadNo : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }

    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    //consolelog("filter values", clearanceFilter)
    specificDispatch(clearanceAction.loadClearanceList(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //date for add clearance
  const currentDate = moment().format("YYYY-MM-DD")
  //consolelog(currentDate, "today")

  useEffect(() => {
    if (clearanceModal === true) {
      setClearanceData({
        ...clearanceData,
        date: currentDate,
      })
    }
  }, [clearanceModal])
  //attachment file state
  const [attachmentFile, setAttachmentFile] = useState("")
  const [clearanceDetails, setClearanceDetails] = useState("")
  // const [leadId, setLeadId] = useState("")

  //View details for Level 1
  const editClearanceStatus = () => {
    setClearanceModalData({
      remarks: "",
    })
    setClearanceLevelAttachment([])
    setPaymentStatus([])
    setClearanceStatus([])
    // setClearanceData({
    //   date: "",
    // })
  }
  const [viewDetails, setViewDetails] = useState(false)
  const [viewLevel2Details, setViewLevel2Details] = useState(false)
  const [levelOneDetails, setLevelOneDetails] = useState("")
  const [levelTwoDetails, setLevelTwoDetails] = useState("")
  const handleLevelOneModal = () => setViewDetails(false)
  const handleLevelTwoModal = () => setViewLevel2Details(false)
  //consolelog(levelOneDetails, "levelOneDetails")
  let slNo = 0
  const clearanceDataTable = !isEmpty(clearance_details)
    ? clearance_details.map((data, index) => {
      slNo = slNo + 1

      //Clearance status
      const clearanceStatus =
        !isEmpty(data) && data.leadClearanceHistory
          ? data.leadClearanceHistory[data.leadClearanceHistory.length - 1]
          : ""

      const clearanceStatusName = !isEmpty(clearanceStatus)
        ? clearanceStatus.type
        : ""
      const processStatusName =
        !isEmpty(clearanceMetaData) &&
          !isEmpty(clearanceMetaData.processStatusOptions) &&
          clearanceMetaData.processStatusOptions &&
          clearanceMetaData.processStatusOptions.length > 0
          ? clearanceMetaData.processStatusOptions.find(
            (_) => _.processStatusId === data.ecProcessStatus
          )
          : "--"
      //consolelog(clearanceStatusName, "clearanceStatusName")
      const eventCount =
        !isEmpty(data) && data.events.length > 0 ? data.events.length : 0
      return {
        _id: data._id,
        sNo: slNo,
        leadNo: data.leadNo,
        colorCode: !isEmpty(processStatusName)
          ? processStatusName.colorCode
          : "",
        isStatus: !isEmpty(processStatusName) ? processStatusName.label : "",
        branchId: data.branchId,
        leadClearanceId: data.leadClearanceId,
        leadClearanceHistory: data.leadClearanceHistory,
        clearanceId: data.clearanceId,
        leadClearance: data.leadClearance,
        branchName: data.branchName,
        clientName: !isEmpty(data.clientId)
          ? data.clientId.firstName + "" + data.clientId.lastName
          : "",
        companyId: data.companyId,
        assignedEcName: !isEmpty(data.leadECAssignPersonName)
          ? data.leadECAssignPersonName
          : "--",
        companyName: data.companyName,
        eventDetails: data.events,
        clientCode: !isEmpty(data.clientId) ? data.clientId.clientNo : "",
        viewDetails: (
          // <Button
          //   className="btn btn-info"

          // >
          <i
            className="fas fa-eye"
            style={{
              color: "#50a5f1",
              fontSize: "16px",
              textAlign: "center",
            }}
            onClick={() => {
              setViewDetails(true)
              setLevelOneDetails(data.leadClearance)
            }}
          ></i>
          // </Button>
        ),
        clearanceStatusName: clearanceStatusName,
        ecClearanceStatusName: data.ecClearanceStatusName,
        events: eventCount,
        clearanceStatus:
          data.ecClearanceStatus === "PS22"
            ? data.ecClearanceStatusName
            : data.ecClearanceStatus === "PS23"
              ? data.ecClearanceStatusName
              : "Pending",
        key: index,
      }
    })
    : []

  //download feature in data table
  const { ExportCSVButton } = CSVExport

  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },

    {
      dataField: "events",
      text: "No Of Events",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div
            className="space-between"
          // onClick={() => setEventDetails(data.events)}
          >
            <span className="badge rounded-pill bg-primary">{row.events}</span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "assignedEcName",
      text: "Ec Agent Name",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "viewDetails",
      text: "Level 1 Details",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "clearanceStatus",
      text: "Clearance Status",
      sort: true,
      formatter: (cellContent, row) => {
       
        return (
          <div className="d-flex flex-row justify-content-between">
            <Button
              onClick={() => {
                setClearanceModal(true)
                setClearanceDetails(row)
                // setLeadId(row._id)
                setAttachmentFile("")
                editClearanceStatus()
              }}
              style={{
                padding: "8px",
                border: "none",
                backgroundColor:
                  !isEmpty(row.clearanceStatusName) &&
                    row.clearanceStatusName === "paid"
                    ? "#34c28f"
                    : row.clearanceStatusName === "partialpaid" ||
                      row.clearanceStatusName === "partialPaid"
                      ? "#f9851b"
                      : row.clearanceStatusName === "unpaid"
                        ? "#c31919ed"
                        : row.clearanceStatusName === "Exception" ||
                          row.clearanceStatusName === "exception" ?
                          "#F1B44C"
                          : row.clearanceStatusName === "complementary" ||
                            row.clearanceStatusName === "Complementary" ?
                            "#50a5f1"
                            : !isEmpty(row.ecClearanceStatus) &&
                              row.ecClearanceStatus === "PS24"
                              ? "#34c28f"
                              : row.ecClearanceStatus === "PS25"
                                ? "#c31919ed"
                                : "#c31919ed",
              }}
            >
              {row.ecClearanceStatus === "PS22"
                ? row.ecClearanceStatusName
                : row.ecClearanceStatus === "PS23"
                  ? row.ecClearanceStatusName
                  : "Pending"}
            </Button>

            <i
              className="fas fa-eye mx-2"
              style={{
                color: "#50a5f1",
                fontSize: "16px",
                marginTop: "10px",
                textAlign: "center",
              }}
              onClick={() => {
                setViewLevel2Details(true)
                setLevelTwoDetails(row.leadClearanceHistory)
              }}
            ></i>
          </div>
        )
      },
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "isStatus",
      text: "EC Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          >
            {row.isStatus}
          </button>
        )
      },
      headerStyle: {
        minWidth: "165px",
      },
    },
  ]

  // pagination options
  const options = {
    sizePerPage: 50,
    totalSize: clearance_details.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //Level one Details
  const levelOneClearanceDate =
    !isEmpty(levelOneDetails) && levelOneDetails
      ? moment(levelOneDetails.clearanceDate).format(dateFormate)
      : "--"
  const levelOneClearanceObj =
    !isEmpty(levelOneDetails) && levelOneDetails ? levelOneDetails : "--"

  const levelOneClearanceAttachment =
    !isEmpty(levelOneDetails) && levelOneDetails.leadClerenceId
      ? levelOneDetails.leadClerenceId.attachment
      : ""
  const levelOneProcessStatus =
    !isEmpty(clearanceMetaData) &&
      !isEmpty(levelOneDetails) &&
      !isEmpty(clearanceMetaData.processStatusOptions) &&
      clearanceMetaData.processStatusOptions &&
      clearanceMetaData.processStatusOptions.length > 0
      ? clearanceMetaData.processStatusOptions.find(
        (_) => _.processStatusId == levelOneDetails.clearanceStatus
      )
      : "--"

  const levelOneCreatedDate =
    !isEmpty(levelOneDetails) && levelOneDetails
      ? moment(levelOneDetails.createdAt)
        .subtract(5, "hours")
        .subtract(30, "minutes")
        .format(`${dateFormate} hh:mm A`)
      : "--"
  //consolelog(levelOneProcessStatus, "levelOneProcessStatus")

  //expand row functionality from bootstrap table

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>

              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                // const dateFormate =
                //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
                return (
                  <tr key={data.id}>
                    <th scope="data">{data.eventNo}</th>
                    <td>
                      {!isEmpty(data.eventDate)
                        ? moment(data.eventDate).format(dateFormate)
                        : "--"}
                    </td>
                    <th>{data.crewAssemblyTime}</th>
                    <td>
                      {!isEmpty(data.venueLocation) ? data.venueLocation : "--"}
                    </td>
                    <td>{!isEmpty(data.venueName) ? data.venueName : "--"}</td>
                    <td>{data.crowdStrength}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //clearance modal data

  const [clearanceModalData, setClearanceModalData] = useState({
    paymentPercent: "",
    attachment: "",
    remarks: "",
  })

  const modalChange = (e) => {
    setClearanceModalData({
      ...clearanceModalData,
      [e.target.name]: e.target.value,
    })
  }

  //modal dropdown
  const [paymentStatus, setPaymentStatus] = useState([])
  const [clearanceStatus, setClearanceStatus] = useState([])
  const [clearanceLevelAttachment, setClearanceLevelAttachment] = useState([])

  // const editClearance=(data)=>{
  //
  //
  // }

  //empid
  // const empId = localStorage.getItem("empId")
  // //consolelog(empId, "my employee Id")

  //handle attachment Change

  const handleAttachmentChange = async (e) => {
    if (e.target.files) {
      //consolelog("qqqq", e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var clearanceAttachmentValue = clearanceLevelAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              clearanceAttachmentValue.push(res.data.data)
              await setClearanceLevelAttachment(clearanceAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }

  // const clearanceDataDetails =
  //   !isEmpty(clearanceDetails) && clearanceDetails.length > 0
  //     ? clearanceDetails[clearanceDetails.length - 1]
  //     : []

  const clearanceId =
    !isEmpty(clearanceDetails) && clearanceDetails.leadClearance
      ? clearanceDetails.leadClearance.leadClerenceId._id
      : ""
  const leadId =
    !isEmpty(clearanceDetails) && clearanceDetails.leadClearance
      ? clearanceDetails.leadClearance.leadClerenceId.leadId
      : ""
  //consolelog(clearanceDetails, "clearanceDetails")
  //consolelog(clearanceDataDetails, "clearanceDataDetails")
  //consolelog(clearanceId, "clearanceId")
  const addClearance = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const applyClearance = {
        leadId: leadId,
        mode: "LEVEL2",
        remarks: clearanceModalData.remarks,
        clearanceId: clearanceId,
        // clearanceId: "64743f52f61a3a61c8dea3db",
        attachment: clearanceLevelAttachment[0],
        clearanceStatus: clearanceStatus.value,
        paymentReceivedPercentage: clearanceModalData.paymentPercent,
        type: paymentStatus.value,
        clearanceDate: clearanceData.date,
      }
      //consolelog(applyClearance, "applyClearance")
      specificDispatch(clearanceAction.addClearance(applyClearance))
      setTimeout(() => {
        specificDispatch(clearanceAction.loadClearanceList())
        toast.success("Clearance Updated Successfully")
        setClearanceModal(false)
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      setClearanceModal(true)
      forceUpdate(1)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />
          {/*Card*/}
          <Row>
            {/* <Card>
                <CardBody>
                  <Col md={12}>
                    <Col xs={12}>
                      <Row style={{ alignItems: 'center' }}>
                          <Col lg={3}>
                            <Card style={{ backgroundColor: "#0D70E2" }} className="text-white-50 cardStyle" >
                              <CardBody onClick={() => setTodayList(true)}>
                                <h4 style={{ color:'#fff' }}>0|0|0</h4>
                                <h6 style={{ color: '#fff' }}> Clearance Report - Todays | MTD | Overall</h6>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col lg={3}>
                            <Card style={{ backgroundColor: '#f1b54c'}} className="text-white-50 cardStyle" >
                              <CardBody  onClick={() => setWeeklyList(true)}>
                                <h4 style={{ color:'#fff' }}>0|0|0</h4>
                                <h6 style={{ color: '#fff' }}>  Clearance Report - Weekly | MTD | Overall</h6>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col lg={3}>
                            <Card style={{ backgroundColor:  '#34c28f' }} className="text-white-50 cardStyle" >
                              <CardBody  onClick={() => setMonthlyList(true)}>
                                <h4 style={{ color:'#fff' }}>0|0|0</h4>
                                <h6 style={{ color: '#fff' }}>  Clearance Report - Monthly | MTD | Overall</h6>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col lg={3}>
                            <Card style={{ backgroundColor: '#f46969' }}className="text-white-50 cardStyle" >      
                              <CardBody  onClick={() => setTotalList(true)}>
                                <h4 style={{ color:'#fff' }}>0|0|0</h4>
                                <h6 style={{ color: '#fff' }}> Clearance Report - Total | MTD | Overall</h6>
                              </CardBody>
                            </Card>
                          </Col>
                      </Row>
                    </Col>
                  </Col>
                </CardBody>
              </Card> */}
          </Row>

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            clearanceMetaData
                              ? clearanceMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={clearanceData.fromDate}
                          max={clearanceData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={clearanceData.toDate}
                          max={clearanceData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead Number"
                          name="leadNo"
                          value={clearanceData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => clearanceFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={clearanceDataTable}
                        columns={columns}
                        search
                        exportCSV
                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-row  ">
                                <Col className="mb-3" md="4">
                                  <div className="d-flex flex-row ">
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                      <div
                                        className="position-relative mt-7"
                                        style={searchBarStyle || null}
                                      >
                                        <SearchBar {...props.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </div>{" "}
                                </Col>
                                <Col>
                                  <ExportCSVButton
                                    className="border float-right mx-10"
                                    style={{
                                      float: "right",
                                      backgroundColor: "#e40d8c",
                                      color: "#ffffff",
                                    }}
                                    {...props.csvProps}
                                  >
                                    Download{" "}
                                  </ExportCSVButton>{" "}
                                </Col>
                                <Col>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    striped={true}
                                    bordered={true}
                                    keyField="_id"
                                    columns={columns}
                                    //  filter={ filterFactory() }
                                    expandRow={expandRow}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {todayList && (
            <Modal show={todayList} size="lg">
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Today Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body style={{ height: "200px" }}></Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setTodayList(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setTodayList(false)
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {weeklyList && (
            <Modal show={weeklyList} size="lg">
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Weekly Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body style={{ height: "200px" }}></Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setWeeklyList(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setWeeklyList(false)
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {monthlyList && (
            <Modal show={monthlyList} size="lg">
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Monthly Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body style={{ height: "200px" }}></Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setMonthlyList(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setMonthlyList(false)
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {totalList && (
            <Modal show={totalList} size="lg">
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Total Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body style={{ height: "200px" }}></Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setTotalList(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setTotalList(false)
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {clearanceModal && (
            <Modal
              show={clearanceModal}
              onHide={handleModal}
              size="lg"
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <Col
                  xl="6"
                  lg="6"
                  md="6"
                  sm="6"
                  xs="6"
                  className="d-flex flex-row"
                >
                  <span>CLEARANCE LEVEL 2</span>
                </Col>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-2">
                    <Label className="employee-label">Clearance Date</Label>
                    <Input
                      type="date"
                      name="date"
                      value={clearanceData.date}
                      onChange={(e) => handleChange(e)}
                      placeholder="Enter"
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                  <Col xl="6" lg="6" md="6" sm="6" xs="6" className="mt-2">
                    <Label className="employee-label">
                      Remarks <span className="required mx-1">*</span>
                    </Label>
                    <Input
                      type="textarea"
                      name="remarks"
                      value={clearanceModalData.remarks}
                      onChange={(e) => modalChange(e)}
                      placeholder="Enter Remarks"
                      classNamePrefix="select2-selection"
                    />
                    {simpleValidator.current.message(
                      "remarks",
                      clearanceModalData.remarks,
                      "required"
                    )}
                  </Col>
                  <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-2">
                    <Label className="employee-label">Payment Status</Label>
                    <Select
                      type="text"
                      name="paymentStatus"
                      value={paymentStatus}
                      onChange={(e) => setPaymentStatus(e)}
                      options={[
                        { label: "Paid", value: "paid" },
                        { label: "Unpaid", value: "unpaid" },
                        { label: "Partial Paid", value: "partialpaid" },
                        { label:"Exception",value:"exception"},
                        { label:"Complementary",value:"complementary"}
                      ]}
                      placeholder="Select Payment Status"
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                  <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-2">
                    <Label className="employee-label">Attachment</Label>
                    <Input
                      type="file"
                      name="clearanceLevelAttachment"
                      onChange={(e) => handleAttachmentChange(e)}
                      placeholder="Enter"
                      classNamePrefix="select2-selection"
                    />
                    {!isEmpty(attachmentFile) ? (
                      <div className="mt-2">
                        <a
                          onClick={() => window.open(attachmentFile, "_blank")}
                        >
                          <span
                            style={{
                              textDecoration: "underline",
                              color: "#E40D8C",
                            }}
                          >
                            View Attachments
                          </span>
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>

                  <Col xl="3" lg="3" md="3" sm="3" xs="3" className="mt-2">
                    <Label className="employee-label">
                      Clearance Status <span className="required mx-1">*</span>
                    </Label>
                    <Select
                      type="text"
                      name="clearanceStatus"
                      value={clearanceStatus}
                      onChange={(e) => setClearanceStatus(e)}
                      options={[
                        { label: "Approved", value: "PS24" },
                        { label: "Recheck", value: "PS25" },
                      ]}
                      placeholder="Select Clearance Status"
                      classNamePrefix="select2-selection"
                    />
                    {simpleValidator.current.message(
                      "clearanceStatus",
                      clearanceStatus,
                      "required"
                    )}
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => {
                    handleModal()
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={(e) => {
                    addClearance(e)
                  }}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {/* {confirmModal && (
            <Modal
              show={confirmModal}
              onHide={handleConfirmModal}
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Confirm Clearance Level</span>
                </div>
              </Modal.Header>
              <Modal.Body>Do you want to confirm for clearance?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleConfirmModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    handleConfirmModal()
                    addClearance()
                  }}
                >
                  Confirm
                </Button>
              </Modal.Footer>
            </Modal>
          )} */}
          {/* Level Two details */}
          {viewDetails && (
            <Modal
              show={viewDetails}
              onHide={handleLevelOneModal}
              size="lg"
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <Col
                  xl="6"
                  lg="6"
                  md="6"
                  sm="6"
                  xs="6"
                  className="d-flex flex-row"
                >
                  <span>Level 1 Details</span>
                </Col>
              </Modal.Header>
              <Modal.Body>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Clearance Date</th>
                      <th>Payment Status</th>
                      <th>Level</th>
                      <th>Payment %</th>
                      {/* <th>Balance Percentage</th> */}
                      <th>Remarks</th>
                      <th>Attachment</th>
                      <th>Status</th>
                      <th>Created By</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(levelOneDetails) && levelOneDetails ? (
                      <tr>
                        <td>{levelOneClearanceDate}</td>
                        <td>
                          {levelOneClearanceObj
                            ? levelOneClearanceObj.type
                            : "--"}
                        </td>
                        <td>
                          {levelOneClearanceObj
                            ? levelOneClearanceObj.mode
                            : "--"}
                        </td>
                        <td>
                          {!isEmpty(levelOneClearanceObj.leadClerenceId) &&
                            levelOneClearanceObj.leadClerenceId
                              .paymentReceivedPercentage
                            ? levelOneClearanceObj.leadClerenceId
                              .paymentReceivedPercentage
                            : "--"}
                        </td>
                       
                        <td>
                          {!isEmpty(levelOneClearanceObj.leadClerenceId) &&
                            levelOneClearanceObj.leadClerenceId.remarks
                            ? levelOneClearanceObj.leadClerenceId.remarks
                            : "--"}
                        </td>
                        <td>
                          <a
                            onClick={() =>
                              window.open(levelOneClearanceAttachment, "_blank")
                            }
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#E40D8C",
                              }}
                            >
                              View
                            </span>
                          </a>
                        </td>
                        <td>
                          <button
                            style={{
                              background:
                                levelOneClearanceObj &&
                                  levelOneClearanceObj.type == "paid"
                                  ? "#34c28f"
                                  : (levelOneClearanceObj &&
                                    levelOneClearanceObj.type ==
                                    "partialpaid") ||
                                    (levelOneClearanceObj &&
                                      levelOneClearanceObj.type ==
                                      "partialPaid")
                                    ? "#f9851b"
                                    :(levelOneClearanceObj &&
                                      levelOneClearanceObj.type ==
                                      "Exception") ||
                                      (levelOneClearanceObj &&
                                        levelOneClearanceObj.type ==
                                        "exception")
                                      ?  "#F1B44C"
                                      :(levelOneClearanceObj &&
                                        levelOneClearanceObj.type ==
                                        "Complementary") ||
                                        (levelOneClearanceObj &&
                                          levelOneClearanceObj.type ==
                                          "complementary")
                                        ?    "#50a5f1"
                                    : "#c31919ed",
                              border: "none",
                              cursor: "pointer",
                              color: "white",
                              padding: "4px 6px",
                              borderRadius: "4px",
                            }}
                          >
                            {levelOneProcessStatus.label}
                          </button>
                        </td>
                        <td>
                          {levelOneClearanceObj &&
                            levelOneClearanceObj.clearanceBy
                            ? levelOneClearanceObj.clearanceBy.name
                            : "--"}
                        </td>
                        <td>{levelOneCreatedDate}</td>
                      </tr>
                    ) : (
                      <tr key={0}>
                        <td className="text-align-center" colSpan={10}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => {
                    handleLevelOneModal()
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {/* Level Two details */}
          {viewLevel2Details && (
            <Modal
              show={viewLevel2Details}
              onHide={handleLevelTwoModal}
              size="lg"
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <Col
                  xl="6"
                  lg="6"
                  md="6"
                  sm="6"
                  xs="6"
                  className="d-flex flex-row"
                >
                  <span>Level 1 Details</span>
                </Col>
              </Modal.Header>
              <Modal.Body>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Clearance Date</th>
                      <th>Payment Status</th>
                      <th>Level</th>
                      <th>Payment %</th>
                   
                      {/* <th>Balance Percentage</th> */}
                      <th>Remarks</th>
                      <th>Attachment</th>
                      <th>Status</th>
                      <th>Created By</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(levelTwoDetails) && levelTwoDetails.length > 0 ? (
                      levelTwoDetails.map((data, index) => {
                        const paymentDetails = !isEmpty(data.leadClerenceId)
                          ? data.leadClerenceId
                          : []
                        const dateFormate =
                          !isEmpty(dateSetting) && dateSetting
                            ? dateSetting
                            : ""
                        const clearanceDate = !isEmpty(data.clearanceDate)
                          ? moment(data.clearanceDate)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(dateFormate)
                          : []
                        const attachment = !isEmpty(paymentDetails.attachment)
                          ? paymentDetails.attachment
                          : ""
                        // const fileUrl = isEmpty(attachment)
                        //   ? ""
                        //   : attachment.substring(attachment.lastIndexOf("/"))
                        //consolelog(fileUrl, "string attachments")
                        // const attachments = isEmpty(fileUrl)
                        //   ? ""
                        //   : "https://api.alphaone.app/uploads" + fileUrl
                        //consolelog(attachments, "attachments")
                        //consolelog(paymentDetails, "paymentDetails")

                        const processStatusName =
                          !isEmpty(clearanceMetaData) &&
                            !isEmpty(clearanceMetaData.processStatusOptions) &&
                            clearanceMetaData.processStatusOptions &&
                            clearanceMetaData.processStatusOptions.length > 0
                            ? clearanceMetaData.processStatusOptions.find(
                              (_) => _.processStatusId == data.clearanceStatus
                            )
                            : "--"
                        const createdAt = !isEmpty(data.createdAt)
                          ? moment(data.createdAt)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(`${dateFormate} hh:mm A`)
                          : []
                        return (
                          <tr key={data._id}>
                            <td>{index + 1}</td>
                            <td>{clearanceDate}</td>
                            <td>{data.type}</td>
                            <td>{data.mode}</td>
                            <td>
                              {!isEmpty(
                                paymentDetails.paymentReceivedPercentage
                              )
                                ? paymentDetails.paymentReceivedPercentage
                                : "--"}
                            </td>
                          
                            <td>
                              {!isEmpty(paymentDetails.remarks)
                                ? paymentDetails.remarks
                                : "--"}
                            </td>
                            <td>
                              <a
                                onClick={() =>
                                  window.open(attachment, "_blank")
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            </td>
                            <td>
                              <button
                                style={{
                                  background:
                                    data.type == "paid"
                                      ? "#34c28f"
                                      : data.type == "partialpaid" ||
                                        data.type == "partialPaid"
                                        
                                        ? "#f9851b"
                                        :data.type == "Exception"||
                                        data.type == "exception"?"#F1B44C"
                                        :data.type == "Complementary" ||
                                        data.type == "complementary" ?"#50a5f1"
                                        : "#c31919ed",
                                  border: "none",
                                  cursor: "pointer",
                                  color: "white",
                                  padding: "4px 6px",
                                  borderRadius: "4px",
                                }}
                              >
                                {processStatusName.label}
                              </button>
                            </td>
                            <td>
                              {!isEmpty(data.clearanceBy)
                                ? data.clearanceBy.name
                                : "--"}
                            </td>
                            <td>{createdAt}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td className="text-align-center" colSpan={10}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => {
                    handleLevelTwoModal()
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

ClearanceLevel2.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClearanceLevel2)
)
